/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import FormCondition from 'cio/app-models/conditions/form';

interface InverseArgs {
  condition: FormCondition;
  disabled: boolean;
  size: string;
  fluid?: boolean;
}

export default class Inverse extends Component<InverseArgs> {
  _inverseOptions = Object.freeze([
    { value: false, label: 'has been submitted' },
    { value: true, label: 'has not been submitted' },
  ]);
}
